import * as validations from '../../../../validations/validations';

import { Col } from 'reactstrap';
import { FormInput } from '../../../';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import IntervalsFormProps from '../IntervalsFormProps';
import React from 'react';
import objectHelper from '../../../../utils/ObjectHelper';
import { observer } from 'mobx-react';

const PlcReadingIntervalField = ({ translate, intervalModel, disabled }: IntervalsFormProps) => <Col>
  <FormInput {...{
    model: new FormInputModel({
      readonly: disabled,
      validationSchema: validations.getBasicNumberSchema(),
      placeholder: translate(x => x.forms.airdome.intervals.plcReadingInterval),
      handleValueModel: new HandleValueModel({
        setValue: intervalModel.plcReadingInterval.setValue,
        inputType: 'number'
      }),
      label: translate(x => x.forms.airdome.intervals.plcReadingInterval),
      inputId: 'PlcReadingInterval',
      value: objectHelper.executeIfNumber(intervalModel.plcReadingInterval.Value, x => x.toString()) || ''
    })
  }} />
</Col>;

export default observer(PlcReadingIntervalField);
